module.exports = __webpack_public_path__ + "static/img/bg_Cloud_2.9033b5e6.png";